export enum FormInputType {
  Textarea = "textarea",
  Text = "text",
  Number = "number",
  Email = "email",
  Password = "password",
  Date = "date",
  NullableNumber = "nullableNumber",
}
